export { default, ProfileInfo, ProfileInfoOwner } from './ProfileInfo';
export type { ProfileInfoProps, ProfileInfoOwnerProps } from './ProfileInfo';
